<template>
  <main class="stage-unlock">
    <form class="stage-unlock__card" @submit.prevent="submit">
      <p class="stage-unlock__label">Тестове середовище</p>
      <h1>Доступ до сайту обмежено</h1>
      <p>{{ checking ? 'Перевіряємо доступ…' : 'Введіть пароль або ключ сесії, щоб відкрити сайт.' }}</p>
      <label for="stage-key">Пароль або ключ сесії</label>
      <input id="stage-key" v-model="key" type="password" autocomplete="off" autofocus
             required :disabled="busy || checking" :aria-invalid="Boolean(error)" aria-describedby="stage-error">
      <p id="stage-error" class="stage-unlock__error" role="alert">{{ error || initialError }}</p>
      <button type="submit" :disabled="busy || checking" :aria-busy="busy">{{ busy ? 'Перевіряємо…' : 'Відкрити сайт' }}</button>
      <button v-if="initialError" type="button" :disabled="checking" @click="retry">Перевірити доступ ще раз</button>
    </form>
  </main>
</template>

<script>
import { verifyStageKey } from '@/services/stageAccess'

export default {
  name: 'StageUnlock',
  props: { unlock: { type: Function, required: true }, checking: Boolean, initialError: { type: String, default: '' }, retry: Function },
  data() { return { key: '', error: '', busy: false } },
  methods: {
    async submit() {
      if (this.busy || this.checking) return
      this.busy = true
      this.error = ''
      try {
        if (!await verifyStageKey(this.key)) {
          this.error = 'Невірний пароль або ключ сесії.'
          return
        }
        this.key = ''
        await this.unlock()
      } catch (error) {
        this.error = error.message || 'Не вдалося відкрити сайт. Спробуйте ще раз.'
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style scoped>
.stage-unlock { position:fixed; inset:0; overflow:auto; display:grid; place-items:center; padding:24px; font-family:'Montserrat',Arial,sans-serif; color:var(--corp-text); background:var(--corp-background); }
.stage-unlock__card { box-sizing:border-box; width:min(460px,100%); padding:32px; border:1px solid var(--corp-border); border-top:4px solid var(--corp-primary); border-radius:20px; background:var(--corp-surface); }
.stage-unlock__label { color:var(--corp-primary-ink); font-size:12px; font-weight:600; text-transform:uppercase; letter-spacing:.08em; }
h1 { font-size:26px; line-height:1.3; }
p { line-height:1.6; }
label { display:block; margin-top:24px; font-size:14px; }
input { box-sizing:border-box; width:100%; margin-top:8px; padding:12px; border:1px solid var(--corp-border); border-radius:10px; font:inherit; background:var(--corp-background); color:var(--corp-text); }
.stage-unlock__error { min-height:24px; font-size:14px; color:#b42318; }
button { width:100%; min-height:48px; padding:12px; border:0; border-radius:24px; font:600 14px 'Montserrat',Arial,sans-serif; background:var(--corp-primary); color:var(--corp-on-primary); cursor:pointer; }
button:disabled { opacity:.65; cursor:wait; }
input:focus-visible, button:focus-visible { outline:3px solid var(--corp-secondary); outline-offset:3px; }
</style>
